export enum StatusNotificationType {
  CARD = 'CARD',
  POP_UP = 'POP_UP',
}
